import { api, HttpError } from './client';
import type {
    CreateNotificationPayload,
    NotificationSubscription,
} from './types';

function siteUrl(siteId: string): string {
    return `/api/sites/${encodeURIComponent(siteId)}/notifications`;
}

export function listNotifications(siteId: string): Promise<NotificationSubscription[]> {
    return api<NotificationSubscription[]>(siteUrl(siteId));
}

export function createNotification(
    siteId: string,
    payload: CreateNotificationPayload,
): Promise<NotificationSubscription> {
    return api<NotificationSubscription>(siteUrl(siteId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    });
}

export async function deleteNotification(siteId: string, id: string): Promise<void> {
    const res = await fetch(`${siteUrl(siteId)}/${encodeURIComponent(id)}`, {
        method: 'DELETE',
        credentials: 'include',
    });
    if (!res.ok) {
        const text = await res.text();
        throw new HttpError(res.status, text || res.statusText);
    }
}
